module.exports = __webpack_public_path__ + "static/img/ent-detail-26.f82abd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-26.jpg
// module id = nUS+
// module chunks = 52